import wxMemberModule from '../pages/wx-member/member/store/module'
import consumingRecordsModule from '../pages/wx-member/member-consuming-records/store/module'
import couponModule from '../pages/wx-member/member-coupon/store/module'
import cancelCouponModule from '../pages/wx-member/cancel-coupon/store/module'
import cardOperationModule from '../pages/wx-member/go-out-management/card-operation/store/module'
import certificationAuditModule from '../pages/wx-member/go-out-management/certification-audit/store/module'
import writeOffOperationModule from '../pages/wx-member/go-out-management/write-off-operation/store/module'
import myRecordModule from '../pages/wx-member/go-out-management/my-record/store/module'
import pointsMailModule from '../pages/wx-member/points-mall/points-mail-home-page/store/module'
import myPointsModule from '../pages/wx-member/points-mall/my-points/store/module'
import exchangeRecordModule from '../pages/wx-member/points-mall/exchange-record/store/module'
import rankEquityModule from '../pages/wx-member/points-mall/rank-equity/store/module'
import productDetailsModule from '../pages/wx-member/points-mall/product-details/store/module'
import productSearchModule from '../pages/wx-member/points-mall/product-search/store/module'
import productOrderModule from '../pages/wx-member/points-mall/product-order/store/module'
import shopptingCartModule from '../pages/wx-member/points-mall/shoppting-cart/store/module'
import paymentDetailsModule from '../pages/wx-member/points-mall/payment-details/store/module'
import pointsMailCashierModule from '../pages/wx-member/points-mall/points-mail-cashier/store/module'
import recordsOfConsumptionModule from '../pages/wx-member/points-mall/records-of-consumption/store/module'
import myOrderModule from '../pages/wx-member/points-mall/my-order/store/module'
import myExtendedInsuranceModule from '../pages/wx-member/points-mall/my-extended-insurance/store/module'
import myStoredValueModule from '../pages/wx-member/points-mall/my-stored-value/store/module'

export default {
  wxMemberModule,
  consumingRecordsModule,
  couponModule,
  cancelCouponModule,
  cardOperationModule,
  certificationAuditModule,
  writeOffOperationModule,
  myRecordModule,
  pointsMailModule,
  myPointsModule,
  exchangeRecordModule,
  rankEquityModule,
  productDetailsModule,
  productSearchModule,
  productOrderModule,
  shopptingCartModule,
  paymentDetailsModule,
  pointsMailCashierModule,
  recordsOfConsumptionModule,
  myOrderModule,
  myExtendedInsuranceModule,
  myStoredValueModule
}



// WEBPACK FOOTER //
// ./src/store/modules.js